import getDependencies from './dependencies';

export default {
  getDependencies,
};
